const types = {
  SET_TWO_STEPS: "SET_TWO_STEPS",
  SET_SETTLEMENT: "SET_SETTLEMENT"
}

export default types
